import React from "react";
import { useNavigate } from "react-router-dom";
import "./errorPage.css"; 

const ErrorPage = () => {
  const navigate = useNavigate();

  const goToHome = () => {
    navigate("/itux-happiness-survey");
  };

  return (
    <div className="error-page-container">
      <div className="error-page-content">
        <h1>Oops! Something Went Wrong</h1>
        <p>
          We couldn’t find what you were looking for. It seems like the location 
          information is either missing or invalid.
        </p>
        <p>
          Please check the URL or go back to the main survey page to continue.
        </p>
        <button className="error-page-button" onClick={goToHome}>
          Go to Survey
        </button>
      </div>
    </div>
  );
};

export default ErrorPage;
